import Vuex from 'vuex'
import Vue from 'vue';
import WebsocketService from './WebsocketService'

import States from "../States"
import ProjectStore from "./store/ProjectStore";
import DomainStatus from "../DomainStatus";
import Packages from "../Packages";
import AnalyticsStore from "./store/AnalyticsStore";
import DomainStore from "./store/DomainStore";
import ChatStore from "./store/ChatStore";

Vue.use(Vuex);

/**
 * Stores the main state
 */
export default new Vuex.Store({
    modules: {
        proj: ProjectStore,
        domains: DomainStore,
        analytics: AnalyticsStore,
        chat: ChatStore
    },

    state: {
        ws: new WebsocketService(),
        minLen: 4,
        maxLen: 10,
        state: States.HOME,
        loadingStatus: "",
        loadingProgress: "",
        seeds: [],
        error: "",
        filtering: false,
        credits: {
            total: 0,
            remaining: 0,
        },
    },


    getters: {

        ws(state) {
            return state.ws;
        },

        api(state) {
            return state.ws.api;
        },

        minLen(state) {
            return state.minLen;
        },

        maxLen(state) {
            return state.maxLen;
        },

        token(state) {
          return state.tokenPromise;
        },

        state(state) {
            return state.state;
        },

        loadingStatus(state) {
            return state.loadingStatus;
        },

        loadingProgress(state){
            return state.loadingProgress;
        },

        seeds(state) {
          return state.seeds;
        },

        error(state) {
            return state.error
        },

        isFiltering(state) {
            return state.filtering;
        },

        credits(state) {
            return state.credits;
        },

        packageById(state, pkgId) {
            return pkgId => {
                if (! pkgId)
                    return null;

                switch (pkgId)
                {
                    case Packages.app.id:
                        return Packages.app;

                    case Packages.full.id:
                        return Packages.full;

                    default:
                        window.console.warn("Unknown package id:", pkgId);
                        return  null;
                }
            }
        },

        isEmailValid(state, email) {
          return email => {
              if (! email)
                  return false;

              //return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email));

              const re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
              return  re.test(email);

          }
        },
    },

    mutations: {
        setState(state, value) {
            state.state = value;
        },

        setLoadingStatus(state, newStatus) {
          state.loadingStatus = newStatus;
        },

        setLoadingProgress(state, newProgress) {
            state.loadingProgress = newProgress;
        },


        setSeeds(state, seeds) {
            state.seeds = seeds;
        },

        setError(state, error) {
            state.error = error;
            window.scroll(0, 0);
        },

        removeError(state) {
          state.error = "";
        },

        setFiltering(state, isFiltering) {
            state.filtering = isFiltering;
        },

        setCredits(state, serverResponse) {
            const credits = {
                remaining: serverResponse['remaining_credits'],
                total: serverResponse['total_credits'],
            };
          window.console.log("setting new credits:", serverResponse, credits);
          state.credits = credits;
        },
    },

    actions: {

        generate(state, payload) {
            state.commit("removeError");
            state.commit("setState", States.GENERATING);
            state.commit("setSeeds", ["..."]);
            state.commit("setLoadingStatus", "Connecting..");
            state.commit("setLoadingProgress", "");

            //don't reset filters here - it puts * in keywords

            payload.router.push({path: "/generating"});


            state.getters.ws.socketPromise.then(socket => {
                state.commit("setLoadingStatus", "Starting the engines..");
                socket.generate(payload.keywords, state, payload.router);
            })
        },

        expectRegen(state, payload) {
            const projId = payload.projectId;
            window.console.log("Regen, payload: ", payload);
            state.commit("removeError");
            state.commit("setLoadingStatus", "Connecting..");
            state.commit("setLoadingProgress", "");

            state.getters.ws.socketPromise.then(socket => {
                state.commit("setLoadingStatus", "Starting the engines..");
                socket.expectRegen(projId, state, payload.onProgress, payload.onFinished);
            })
        },

        showResults(state, payload) {

            if (state.getters.state !== States.GENERATING && state.getters.state !== States.FETCHING) {
                const newState = state.getters.state;
                window.console.warn("Ignoring fetched results - state is no longer fetching or generating:", newState);
                return;
            }
            state.commit("resetFilters");
            state.commit("removeError");
            state.commit("setCredits", payload);
            state.commit("loadProject", payload);
            state.dispatch("fetchDomainStatus", payload.results);
            const slug = payload.slug;

            payload.router.replace({ path: `/results/${slug}` });
            window.scroll(0, 0);
        },


        fetchResults(state, payload) {
            state.commit("setState", States.FETCHING);
            state.commit("removeError");
            state.commit("resetFilters");

            //Hide any previous progress msgs:
            state.commit("setLoadingStatus", "");
            state.commit("setLoadingProgress", "");

            state.getters.ws.socketPromise.then(socket => {
                socket.fetchResults( payload.filters ).then(results => {
                    if (state.getters.state !== States.FETCHING) {
                        window.console.warn(`Status no longer fetching, ignoring: ${state.getters.state}`);
                        return;
                    }

                    results.router = payload.router;
                    state.dispatch("showResults", results);
                })

            });
        },

        // Filters existing project instead of loading a new one - doesn't redirect to /loading
        //and commits setFiltering,true
        filter(state, payload) {
            state.commit("setFiltering", true);
            state.commit("removeError");

            window.console.log("Re-filtering..", payload.filters );

            return new Promise(function (resolve, reject) {
                state.getters.ws.socketPromise.then(socket => {
                    socket.fetchResults( payload.filters ).then(results => {
                        window.console.log("Got results", results);


                        //If filtering by votes, use below to clear existing results (page should also have been
                        //reset to 1, which is being done in ResultsView#filterByVote )
                        if (payload.clearExisting)
                            state.commit("clearResults");

                        //Append new results to existing results:
                        //state.commit("addResults", results.results);
                        state.commit("setCredits", results);
                        state.commit("loadProject", results);
                        window.console.log(results.results);
                        state.dispatch("fetchDomainStatus", results.results);
                        state.commit("setFiltering", false);
                        state.commit("removeError");
                        resolve(results);
                    })

                });
            })
        },


        showTempError(state, error) {
            state.commit("setError", error);
            setTimeout(() => state.commit("removeError"), 5000);
        },

        prePurchaseInfo(state) {
            return new Promise(function(resolve, reject) {
                state.getters.ws.socketPromise.then(socket => {
                    socket.prePurchaseInfo().then(result => {
                        resolve(result);
                    });
                });
            })
        },

        reqPaymentIntent(state, payload) {
            return new Promise(function(resolve, reject) {
                state.getters.ws.socketPromise.then(socket => {
                   socket.reqPaymentIntent(payload).then(result => {
                     resolve(result);
                   });
                });
            })
        },

        prepareForMoney(state, payload) {
            return new Promise(function(resolve, reject) {
                state.getters.ws.socketPromise.then(socket => {
                    socket.prepareForMoney(payload).then(result => {
                        resolve(result);
                    });
                });
            })
        },



        txnStatus(state, payload) {
            return new Promise(function(resolve, reject) {
                state.getters.ws.socketPromise.then(socket => {
                    socket.txnStatus(payload).then(result => {
                        resolve(result);
                    });
                });
            })
        },
   }
});
